module.exports = __webpack_public_path__ + "static/zegar-ac52ab06ae2b957eea10055f6c9a85f6.png";